import { useRef, useState } from "react";

function VideoCard({ id, name, title, description, image, yt_url }) {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div className="faculty-box">
        <figure onClick={() => setVisible(true)}>
          <img
            src={`assets/images/vedio_youtube/${image}`}
            data-bs-toggle="modal"
            data-bs-target={`#exampleModal${id}`}
          />
        </figure>
        <div className="text-left">
          <h3 className="name">{name}</h3>
          <p className="title">{title}</p>
          <p className="description">{description}</p>
        </div>
      </div>
      
      <div className={`video-youtube-popup ${visible && "show"}`}>
        <div className="wrapper">
          <div className="close-btn" onClick={() => setVisible(false)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </div>
          {visible && (
            <iframe
            width="560"
            height="315"
            src={yt_url}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          )}
        </div>
      </div>
    </>
  );
}
export default VideoCard;
